module.exports = __webpack_public_path__ + "static/media/default-photo2.2f009edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/default-photo2.png
// module id = 868
// module chunks = 0